import { Link } from '@mui/material';

import { legalDocumentRoute, ROUTES } from '@/constants/routes';

/**
 * The published `employer-terms` slug (`LegalPolicy` on the server). A public, bookmarked address, so it
 * is as fixed as `ROUTES.legalTerms` — it is not a list of documents held on the client.
 */
const EMPLOYER_TERMS_PATH = legalDocumentRoute('employer-terms');

/**
 * "the Terms of Service, Employer Terms and Privacy Policy", as links — what a company registrant
 * agrees to (ADR-0026). The Terms of Service incorporates the Employer Terms by reference; they are
 * named here because they are the terms that actually govern a workspace: approval, member roles,
 * job postings and the obligations that come with candidate data.
 *
 * Opens in a new tab so reading the terms does not discard the half-filled wizard.
 */
export function CompanyTermsLinks() {
  return (
    <>
      <Link href={ROUTES.legalTerms} target="_blank" rel="noopener noreferrer">
        Terms of Service
      </Link>
      ,{' '}
      <Link href={EMPLOYER_TERMS_PATH} target="_blank" rel="noopener noreferrer">
        Employer Terms
      </Link>{' '}
      and{' '}
      <Link href={ROUTES.legalPrivacy} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </Link>
    </>
  );
}
